export default {
  methods: {
    fadeIn() {
      this.animationFrom({ opacity: 0 })
    },

    fadeOut() {
      this.animationTo({ opacity: 0 })
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/util/mixins/fade.js